<template>
  <div class="home-content-page-v">
    <div style="margin-bottom: 1rem;display: flex;">
      <el-input v-model="driver_name" placeholder="请输入姓名"></el-input>
    </div>
    <content-title title="驾驶员管理"></content-title>
    <div class="output-content" v-loading="loading">
      <mii-base-table :datas="showDriverList" :table_actions="table_actions" :table_style="2" :ths="ths" @clickTdBtn="clickTdBtn"></mii-base-table>
    </div>
  </div>
</template>

<script>
import ContentTitle from '@/components_bit/ContentTitle'
import MiiBaseTable from '@/components_bit/MiiBaseTable'
import {
  driver
} from '@/api/oli_api'

export default {
  components: {
    ContentTitle,
    MiiBaseTable
  },
  data () {
    return {
      loading: false,
      driver_name: '',
      driver_list: [],
      ths: [{
        key: '人员代码',
        label: '人员代码'
      },
      {
        key: '所属车队',
        label: '车队'
      },
      {
        key: '姓名',
        label: '姓名'
      },
      {
        key: '人员状态',
        label: '状态'
      },
      {
        key: '黑名单',
        label: '黑名单'
      }]
    }
  },
  computed: {
    showDriverList: {
      get () {
        let data = []
        this.driver_list.forEach((item) => {
          if (item['姓名'].includes(this.driver_name)) {
            data.push(item)
          }
        })
        return data
      }
    },
    table_actions: {
      get () {
        let data = [{
          label: '拉黑',
          key: 'black',
          hideByData: (data) => {
            return !data['黑名单']
          }
        },
        {
          label: '取消黑名单',
          key: 'black_back',
          hideByData: (data) => {
            return data['黑名单']
          }
        }]
        return data
      }
    }
  },
  created () {
    this.loadDriverList()
  },
  methods: {
    loadDriverList () {
      this.loading = true
      let parm = {
        action: 'get_driver',
        data: {}
      }
      driver(parm).then((data) => {
        this.driver_list = data
        this.loading = false
      })
    },
    clickTdBtn (dataMap) {
      if (dataMap.key === 'black') {
        this.changeBlack(dataMap.data, 'black')
      } else if (dataMap.key === 'black_back') {
        this.changeBlack(dataMap.data, 'black_back')
      }
    },
    changeBlack (data, type) {
      this.loading = true
      let parm = {
        action: 'driver_change_black',
        data: {
          'driver': data,
          'status': type === 'black_back' ? 'white' : 'black'
        }
      }
      driver(parm).then((data) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'success',
          title: '系统提示',
          message: data.msg
        })
        this.loading = false
        this.loadDriverList()
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.output-btn {
  color:#fff;
  background-color: @bak-color-2;
  padding: 0.5em 1.5em;
  text-align: center;
  border-radius: 0.3em;
  letter-spacing: 0.1em;
}
.output-content {
  .content-shadow;
  .content-bottom-radius;
  display: flex;
  background-color: #fff;
}
.gas-list {
  display: flex;
  flex: 1;
  justify-content: flex-start;
  flex-wrap: wrap;
  span {
    padding:0.1rem 0.7rem;
    border-radius: 0.2rem;
    width: auto !important;
    background-color: #eee;
    margin: 0 0.7rem 0.5rem 0;
  }
  .icon-105 {
    margin-left: 0.5rem;
    color: red;
  }
}
.case-form {
  display: flex;
  flex-wrap: wrap;
}
.one-input {
  display: flex;
  justify-content: space-between;
  width: 46%;
  margin: 1rem 2%;
  span {
    width: 9rem;
    font-size: 0.9rem;
  }
}
.xz-gas {
  .one-input {
    width: 100%;
  }
}
.checkbox-label {
  .output-btn {
    margin-left: 3em;
  }
}
.btm-btn {
  margin: 1em 0 0 2em;
}
.gas-info {
  height: 3rem;
  margin-bottom: 1rem;
  .content-shadow;
  .content-bottom-radius;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  .info-one {
    text-align: center;
    flex: 1;
    display: flex;
    align-items: center;
    color: #666;
    font-size: 1.1rem;
    span {
      color: #999;
      margin-right: 1rem;
    }
  }
}
.file-input {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.m-line {
  width: 2px;
  height: 15em;
  background-color: #ccc;
  margin: 1.5em 2.2em 0 0;
}
.output-content-1 {
  flex: 1;
  margin: 1em 2.5em 7em;
  display: flex;

}
.checkbox-content {
  display: flex;
  flex-direction: column;
  span {
    line-height: 1;
    font-size: 1.13em;
    padding-bottom: 0.5em;
    color: @bak-color-2;
  }
}
.checkbox-one {
  display: flex;
  align-items: center;
  height: 3.4em;
  font-size: 1em;
  color:@bak-color-1;
  img {
    padding-right: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// driver.vue?683bf0b4